module.exports = __webpack_public_path__ + "img/turkfinansal-logo.8a1c9f78.svg";